"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shadows = exports.spacing = exports.border = exports.primaryTextAlt = exports.primaryText = exports.primaryBackground = void 0;
const colors_1 = require("./colors");
exports.primaryBackground = {
    backgroundColor: colors_1.colors.primaryFallback,
    backgroundImage: colors_1.colors.primary,
    backgroundSize: '100% 100%',
};
exports.primaryText = {
    color: colors_1.colors.primaryFallback,
    backgroundImage: colors_1.colors.primary,
    backgroundSize: '100% 100%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
};
exports.primaryTextAlt = {
    color: colors_1.colors.blueLight,
};
exports.border = {
    radius: {
        small: '12px',
        medium: '16px',
        large: '24px',
    },
    style: '1px solid',
};
exports.spacing = { unit: 8 };
exports.shadows = {
    low: '0px 1px 5px rgba(0, 0, 0, 0.25)',
    middle: '0px 3px 10px rgba(0, 0, 0, 0.15)',
    high: '0px 2px 16px rgba(0, 0, 0, 0.15)',
    soft: '0px 0px 42px rgba(0, 0, 0, 0.1)',
};
//# sourceMappingURL=common.js.map